<template>
  <div class="flex-none flex items-center justify-center">
    <div
      v-on="$listeners"
      @mouseover="hover=true"
      @mouseleave="hover=false"
      class="margin-one flex flex-row text-base hover:no-underline border border-solid rounded-md py-2 px-5 cursor-pointer"
      :style="{
        color: button.fontColor,
        'font-family': survey.fontFamily,
        'background-color': button.bgColor,
        'border-color': button.borderColor,
      }"
      :class="{'hover-active': hover}"
      v-text="buttonText"
    >
    
    </div>
    <!-- Show 'Next' text if step contains no options or allow multiple; else show 'Skip' text  -->
  </div>
</template>

<script>

export default {
  name: 'survey_button',
  props: ["survey", "step", "text"],
      data(){
      return {
        hover: false
      }
    },
  computed: {

    button(){
      return this.survey.buttons[0];
    },
    buttonText(){
      if (this.text) return this.text;
      
      if (this.step.options.length < 1 || this.step.allow_many)
      return this.button.next_text
      else return this.button.skip_text;

    }
  }
};
</script>

<style>
.margin-one{
  margin: 1px
}
.hover-active{
  border-width: 2px;
  margin: 0;
}

</style>
